module.exports = __webpack_public_path__ + "img/cutout_bg_remover.6b84490.png";